import * as React from 'react';

import {
  Create,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  useTranslate,
} from 'react-admin';

import { MyTranslatableInputs } from '../../components/MyTranslatableInputs';

const ErrorCodesCreate = () => {
  const translate = useTranslate();

  return (
    <Create>
      <SimpleForm>
        <ReferenceInput
          source="section"
          reference="sections"
          validate={[required()]}
          perPage={1000}
        >
          <SelectInput
            optionText="name"
            label={translate('resources.error_codes.fields.section')}
          />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.section ? (
              <ReferenceInput
                source="category"
                reference="categories"
                perPage={1000}
                filter={{ section_q: formData.section }}
                validate={[required()]}
                {...rest}
              >
                <SelectInput
                  optionText="name"
                  label={translate('resources.error_codes.fields.category')}
                />
              </ReferenceInput>
            ) : null
          }
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.category ? (
              <ReferenceInput
                source="serie"
                reference="series"
                perPage={1000}
                filter={{ category_q: formData.category }}
                validate={[required()]}
                {...rest}
              >
                <SelectInput
                  optionText="name"
                  label={translate('resources.error_codes.fields.serie')}
                />
              </ReferenceInput>
            ) : null
          }
        </FormDataConsumer>
        <TextInput
          source="name"
          label={translate('resources.error_codes.fields.name')}
        />
        <MyTranslatableInputs groupKey="description">
          <TextInput
            source="descriptionTranslated"
            label={translate('resources.error_codes.fields.description')}
            multiline
            fullWidth
          />
        </MyTranslatableInputs>
        <NumberInput
          source="order"
          label={translate('resources.error_codes.fields.order')}
          min={1}
          max={99}
          step={1}
          defaultValue={99}
          validate={[required()]}
          style={{ width: 160 }}
        />
      </SimpleForm>
    </Create>
  );
};

export default ErrorCodesCreate;
